import {combineReducers} from 'redux';
import UserReducer from './UserReducer';
import AuthorReducer from './AuthorReducer';
import AdminReducer from './AdminReducer';
import BookReducer from './BookReducer';

export default combineReducers({
    UserReducer,
    AuthorReducer,
    BookReducer,
    AdminReducer
})